export enum EInvoiceAccountQueryKeys {
  GET_EINVOICE_ACCOUNT_LIST = 'GET_EINVOICE_ACCOUNT_LIST',
}
